import * as React from 'react'
import {
    NatAbsenceContactAddress,
    NatContactAddressOnEmergency,
    NatFamilyStructure,
    NatRentAdminContactAddress,
} from '../NatResidentApplicationInterface'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {APPLY_CATEGORY, RESIDENCE_STYLE} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import NatResidentContactAddressOnEmergencyConfirmView from './NatResidentContactAddressOnEmergencyConfirmView'
import NatResidentAbsenceContactAddressConfirmView from './NatResidentAbsenceContactAddressConfirmView'
import NatResidentFamilyStructureConfirmView from './NatResidentFamilyStructureConfirmView'
import NatResidentRentAdminContactAddressConfirmView from './NatResidentRentAdminContactAddressConfirmView'
import {getFormattedDate} from '../helper/NatContactAddressOnEmergencyHelper'

interface Props {
    residenceStyle: Nullable<string>
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    occupancyDate: Nullable<string>
    contactAddressOnEmergency: Nullable<NatContactAddressOnEmergency>
    absenceContactAddress: Nullable<NatAbsenceContactAddress>
    rentAdminContactAddressFlag: Nullable<string>
    rentAdminContactAddress: Nullable<NatRentAdminContactAddress>
    familyStructureList: Nullable<NatFamilyStructure[]>
    applyFlag?: boolean
}

const NatResidentContactAddressOnEmergencyConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        residenceStyle, applicantFamilyName, applicantFirstName,
        occupancyDate, contactAddressOnEmergency, absenceContactAddress,
        familyStructureList, rentAdminContactAddressFlag, rentAdminContactAddress
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.CONTACT_ADDRESS_ON_EMERGENCY.label
    const residenceStyleLabel = (residenceStyle) ?
        RESIDENCE_STYLE.codeToEnumConstants(residenceStyle).label : ''
    const occupancyDateLabel = (occupancyDate) ?
        getFormattedDate(occupancyDate) : ''

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
            </>
        }
        <NatResidentApplicationDetailConfirmItem
            title={'居住形態'}
            items={[residenceStyleLabel]}
        />
        <BlockSpacer height={'5px'}/>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
                <BlockSpacer height={'5px'}/>
            </>
        }
        {(residenceStyle === RESIDENCE_STYLE.UNIT_OWNER.value ||
                residenceStyle === RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value) &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'入居年月日'}
                    items={[occupancyDateLabel]}
                />
                <BlockSpacer height={'5px'}/>
            </>
        }
        {/* 緊急時連絡先 */}
        <NatResidentContactAddressOnEmergencyConfirmView
            residenceStyle={residenceStyle}
            contactAddressOnEmergency={contactAddressOnEmergency}
        />
        {/* 不在連絡先 */}
        <NatResidentAbsenceContactAddressConfirmView
            absenceContactAddress={absenceContactAddress}
        />
        {/* 家族構成 */}
        {(residenceStyle === RESIDENCE_STYLE.UNIT_OWNER.value ||
                residenceStyle === RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value) &&
                    <NatResidentFamilyStructureConfirmView
                        familyStructureList={familyStructureList}
                    />
        }
        {/* 賃貸管理者連絡先 */}
        {(residenceStyle === RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value ||
                residenceStyle === RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value) &&
            <NatResidentRentAdminContactAddressConfirmView
                rentAdminContactAddressFlag={rentAdminContactAddressFlag}
                rentAdminContactAddress={rentAdminContactAddress}
            />
        }
    </>)
}

NatResidentContactAddressOnEmergencyConfirm.displayName = 'NatResidentContactAddressOnEmergencyConfirm'
export default NatResidentContactAddressOnEmergencyConfirm